<template>
        <div class="text-area">
            <h2>{{textTitle}}</h2>
            <p></p>
            <p v-html="line" v-for="line in textLinesArray" :key="line">
                {{ line }}
            </p>
        </div>
</template>
<script>

export default {
  components: {
    
  },
  props: ['textTitle', 'textLinesArray']
}
</script>
<style scoped>
.text-area{
    padding-right: 10%;
}
</style>